import axiosInstance from "../../../api/axiosInstance";

let getRentalReview = () => {
    return new Promise((resolve, reject) => { 
        axiosInstance.get(process.env.REACT_APP_API + "/medidas/indices/get/all").then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

let getExceptionCertificate = () => {
    return new Promise((resolve, reject) => { 
        axiosInstance.get(process.env.REACT_APP_API + "/certificates/retenciones/get").then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

let getEnergeticCertificate = () => {
    return new Promise((resolve, reject) => { 
        axiosInstance.get(process.env.REACT_APP_API + "/certificates/energeticos/get").then(response=> {
            resolve(response, "200", 'Success');
        }).catch(error => {
            resolve([], '404', error.response);
        });
    })
}

export {
    getRentalReview,
    getExceptionCertificate,
    getEnergeticCertificate
}